class IncludeMembersSplitTunnelingDatatable {
    constructor(splitTunnelingInstance){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.splitTunnelingInstance = splitTunnelingInstance;
        this.datatable = this.init('#include-members-split-tunneling-datatable', organizationID);
        this.initActions(organizationID);
    }
    init(el, organizationID){
        const thisClass = this;

        //
        // Pipelining function for DataTables. To be used to the `ajax` option of DataTables
        //
        $.fn.dataTable.pipeline = function (opts) {
            // Configuration options
            var conf = $.extend(
                {
                    pages: 5, // number of pages to cache
                    url: '', // script url
                    data: null, // function or object with parameters to send to the server
                    // matching how `ajax.data` works in DataTables
                    method: 'GET', // Ajax HTTP method
                },
                opts
            );

            // Private variables for storing the cache
            var cacheLower = -1;
            var cacheUpper = null;
            var cacheLastRequest = null;
            var cacheLastJson = null;

            return function (request, drawCallback, settings) {
                var ajax = false;
                var requestStart = request.start;
                var drawStart = request.start;
                var requestLength = request.length;
                var requestEnd = requestStart + requestLength;

                if (settings.clearCache) {
                    // API requested that the cache be cleared
                    ajax = true;
                    settings.clearCache = false;
                } else if (cacheLower < 0 || requestStart < cacheLower || requestEnd > cacheUpper) {
                    // outside cached data - need to make a request
                    ajax = true;
                } else if (
                    JSON.stringify(request.order) !== JSON.stringify(cacheLastRequest.order) ||
                    JSON.stringify(request.columns) !== JSON.stringify(cacheLastRequest.columns) ||
                    JSON.stringify(request.search) !== JSON.stringify(cacheLastRequest.search)
                ) {
                    // properties changed (ordering, columns, searching)
                    ajax = true;
                }

                // Store the request for checking next time around
                cacheLastRequest = $.extend(true, {}, request);

                if (ajax) {
                    // Need data from the server
                    if (requestStart < cacheLower) {
                        requestStart = requestStart - requestLength * (conf.pages - 1);

                        if (requestStart < 0) {
                            requestStart = 0;
                        }
                    }

                    cacheLower = requestStart;
                    cacheUpper = requestStart + requestLength * conf.pages;

                    request.start = requestStart;
                    request.length = requestLength * conf.pages;

                    // Provide the same `data` options as DataTables.
                    if (typeof conf.data === 'function') {
                        // As a function it is executed with the data object as an arg
                        // for manipulation. If an object is returned, it is used as the
                        // data object to submit
                        var d = conf.data(request);
                        if (d) {
                            $.extend(request, d);
                        }
                    } else if ($.isPlainObject(conf.data)) {
                        // As an object, the data given extends the default
                        $.extend(request, conf.data);
                    }

                    return $.ajax({
                        type: conf.method,
                        url: conf.url,
                        data: request,
                        dataType: 'json',
                        cache: false,
                        success: function (json) {
                            cacheLastJson = $.extend(true, {}, json);

                            if (cacheLower != drawStart) {
                                json.data.splice(0, drawStart - cacheLower);
                            }
                            if (requestLength >= -1) {
                                json.data.splice(requestLength, json.data.length);
                            }

                            drawCallback(json);
                        },
                    });
                } else {
                    let json = $.extend(true, {}, cacheLastJson);
                    json.draw = request.draw; // Update the echo for each response
                    json.data.splice(0, requestStart - cacheLower);
                    json.data.splice(requestLength, json.data.length);

                    drawCallback(json);
                }
            };
        };

        // Register an API method that will empty the pipelined data, forcing an Ajax
        // fetch on the next draw (i.e. `table.clearPipeline().draw()`)
        $.fn.dataTable.Api.register('clearPipeline()', function () {
            return this.iterator('table', function (settings) {
                settings.clearCache = true;
            });
        });

        const datatable =  $(el).DataTable({
            earchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ordering: false,
            ajax: $.fn.dataTable.pipeline({
                url: '?do=getIncludeMembersSplitTunneling',
                type: 'POST',
                pages: 500,
                data: {
                    organizationID: organizationID
                }
            }),
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function (settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=include-members-split-tunneling-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            createdRow: function (row, data) {
                /** Add classes to row for easy count number of members/groups */
                if (data.isMember) {
                    $(row).addClass('is-member');
                } else {
                    $(row).addClass('is-group');
                }
            },
            columns: [
                {
                    data: 'uuid',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">\n' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="'+el+' .form-check-input" data-kt-check-all="true" value="1"/>\n' +
                        '   </div>',
                    class: 'py-1 mw-25px',
                    sortable: false,
                    render: function (data, type, row) {
                        if (row['isMember']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="members[]" value="' + row['uuid'] + '"/>' +
                                '</div>';
                        } else {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="groups[]" value="' + row['uuid'] + '"/>' +
                                '</div>';
                        }
                    }
                },
                {
                    data: 'name',
                    title: 'Member / Group',
                    sortable: false,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        if (row['isMember']) {
                            return new MemberInfoGenerator(row).generateTableMember();
                        } else {
                            return new GroupInfoGenerator().generateMemberTableView(row['name'], row['edit'], row['uuid'], row['numberOfMembers']);
                        }
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    class: 'py-1 pe-3 text-center',
                    sortable: false,
                    render: function (data, type, row) {
                        if(row['edit'] || row['delete']) {
                            return '<div class="datatable-action min-w-3" id="' + row['uuid'] + '">' +
                                '   <div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary include-members-members-split-tunneling cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">' +
                                '        <span class="svg-icon svg-icon-3">' +
                                '             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                  <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                  <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                  <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '              </svg>' +
                                '         </span>' +
                                '    </div>' +
                                '</div>';
                        }
                        return '';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#customSplitTunnelingMembers_wrapper [data-kt-docs-table-filter=search]').parent().hide();
                $('#include-members-split-tunneling-datatable_wrapper').hide();
            } else {
                $('#customSplitTunnelingMembers_wrapper [data-kt-docs-table-filter=search]').parent().show();
                $('#include-members-split-tunneling-datatable_wrapper').show();
            }
        }).on('draw', function () {
            thisClass.removeSelectedRows(organizationID);
            $('#include-members-split-tunneling-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            if(datatable.page.info().recordsTotal !== 0){
                $('#include-members-split-tunneling-datatable_wrapper').show();
                $('#customSplitTunnelingMembers_wrapper [data-kt-docs-table-filter=search]').parent().show();

                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            } else {
                $('#customSplitTunnelingMembers_wrapper [data-kt-docs-table-filter=search]').parent().hide();
                $('#include-members-split-tunneling-datatable_wrapper').hide();
            }
        }).on('select', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows === displayedRows){
                $('#include-members-split-tunneling-datatable_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows !== displayedRows){
                $('#include-members-split-tunneling-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '#customSplitTunnelingMembers_wrapper input[data-kt-docs-table-filter=search]');
        return datatable;
    }
    initActions(organizationID){
        const thisClass = this;
        /** Select All rows */
        $(document).on('click','#include-members-split-tunneling-datatable_wrapper [data-kt-check-all]',function(e){
            if ($(this).is(':checked')) {
                thisClass.datatable.rows().select();
            } else {
                thisClass.datatable.rows().deselect();
            }
        });

        $(document).on('click','.include-members-members-split-tunneling',function(e){
            let name;
            let memberOrGroupID = $(this).parent()[0].id;
            let row = $(this).closest('tr');
            let isMember = false;
            if(row.find('input[name=members\\[\\]]').length === 1){
                isMember = true;
                name = $(this).closest('tr').find('span[data-member-name]').attr('data-member-name');
            } else {
                name = $(this).closest('tr').find('span[data-group-name]').attr('data-group-name');
            }
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to delete `+(name !== undefined ? `<b>`+name+`</b>` : `this Member/Group?`)+`?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/split-tunneling?do=removeIncludeMembersSplitTunneling&organizationID='+organizationID+(isMember ? '&memberIDs='+memberOrGroupID : '&groupIDs='+memberOrGroupID))
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success((isMember ? 'Member' : 'Group')+' has been deleted.');
                        thisClass.datatable.clearPipeline();
                        thisClass.datatable.ajax.reload();
                        thisClass.splitTunnelingInstance.initAddMembersOrGroupTagify();
                    }
                }
            });
        });
    }
    removeSelectedRows(organizationID){
        const thisClass = this;
        // Toggle selected action toolbar
        // Select all checkboxes
        const container = document.querySelector('#customSplitTunnelingMembers_wrapper');
        const checkboxes = container.querySelectorAll('[type="checkbox"]');

        // Select elements
        const deleteSelected = container.querySelector('[data-kt-docs-table-select="delete_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function () {
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Deleted selected rows
        if(deleteSelected){
            deleteSelected.addEventListener('click', function () {
                let selectedIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to delete selected Members/Groups?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                returnFocus: false,
                    preConfirm: () => {
                        return fetch('/split-tunneling?do=removeIncludeMembersSplitTunneling&organizationID='+organizationID+(selectedIDs.memberIDs.length > 0 ? '&memberIDs='+selectedIDs.memberIDs : '')+(selectedIDs.groupIDs.length > 0 ? '&groupIDs='+selectedIDs.groupIDs : ''))
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value === 'deleted') {
                            toastr.success('Members/Groups have been deleted.');
                            thisClass.datatable.clearPipeline();
                            thisClass.datatable.ajax.reload();
                            thisClass.splitTunnelingInstance.initAddMembersOrGroupTagify();
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const container = document.querySelector('#customSplitTunnelingMembers_wrapper');
        const toolbarBase = container.querySelector('[data-kt-docs-table-toolbar="base"]');
        const toolbarSelected = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarBase && toolbarSelected){
            const selectedCount = container.querySelector('[data-kt-docs-table-select="selected_count"]');

            // Select refreshed checkbox DOM elements
            const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarBase.classList.add('d-none');
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarBase.classList.remove('d-none');
                toolbarSelected.classList.add('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Define variables
        const container = document.querySelector('#customSplitTunnelingMembers_wrapper');
        // Select refreshed checkbox DOM elements
        const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

        let memberIDs = [];
        let groupIDs = [];

        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                if(c.attributes.name.value === 'members[]'){
                    memberIDs.push(c.value);
                } else {
                    groupIDs.push(c.value);
                }
            }
        });
        return {
            memberIDs: memberIDs,
            groupIDs: groupIDs
        };
    }
}
window.IncludeMembersSplitTunnelingDatatable = IncludeMembersSplitTunnelingDatatable;